<template>
  <div :id="sectionId" :class="numbered ? 'cm-block-head' : 'cm-page-head'">
    <span v-if="numbered">{{ number }}</span>
    <div class="cm-block-copy">
      <h2 v-if="numbered">{{ title }}</h2>
      <h1 v-else>{{ title }}</h1>
      <p>{{ description }}</p>
    </div>
    <button
      v-if="collapsible"
      type="button"
      class="cm-section-toggle"
      :class="{ 'is-collapsed': collapsed }"
      :aria-label="collapsed ? $t('CM_SHOW_SECTION') : $t('CM_HIDE_SECTION')"
      @click="onToggle"
    >
      <i class="bi bi-chevron-up"></i>
    </button>
  </div>
</template>

<script>
import { hiddenStore, toggleSection } from "@/models/content-monitoring/hidden-panels";

export default {
  name: "Cm-section-head",
  props: {
    sectionId: { type: String, required: true },
    block: { type: String, default: "" },
    title: { type: String, required: true },
    description: { type: String, default: "" },
    numbered: { type: Boolean, default: false },
    number: { type: String, default: "" },
    collapsible: { type: Boolean, default: false },
  },
  computed: {
    collapsed() {
      const ids = hiddenStore.ids;
      return !!this.block && ids.indexOf(this.block) !== -1;
    },
  },
  methods: {
    onToggle() {
      if (!this.block) return;
      toggleSection(this.block);
    },
  },
};
</script>
